
/**
 * 메시지 역할
 */
export type GetConversation200AllOfThreeMessagesItemRole = typeof GetConversation200AllOfThreeMessagesItemRole[keyof typeof GetConversation200AllOfThreeMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetConversation200AllOfThreeMessagesItemRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
